import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { selectMyNumJacks } from '../redux/reducers/selfDataReducer';
import { useAppSelector } from '../redux/store';
import { ValueDisplay } from './valueDisplay';
export const MyJacksDisplay = () => {
    const myNumJacks = useAppSelector(selectMyNumJacks);
    if (myNumJacks === undefined) {
        return null;
    }
    return (_jsx("div", { children: _jsx(ValueDisplay, { label: 'Jacks', type: 'jacks', value: myNumJacks, isLabelFirst: true }) }));
};
